export const EXAM_RISK_TAB = 'Risk';
export const RH_CONFIG_TYPE_CAPTION = 'Type';
export const RH_CONFIG_PROCEURE_TYPE = 'Procedure';
export const RH_CONFIG_CANCER_TYPE = 'Cancer';
export const RH_CONFIG_HORMONE_TYPE = 'Hormone';
export const RH_CONFIG_BRCA_TYPE = 'BRCA';
export const RH_CONFIG_PROCEURE_TYPE_CAPTION = 'Procedure';
export const RH_CONFIG_PROCEURE_RESULT_CAPTION = 'Result';
export const RH_CONFIG_RELATIVE_CAPTION = 'Relative';
export const RH_CONFIG_PARENT_CAPTION = 'Parent';


// WEBPACK FOOTER //
// ./src/scripts/constants/exam-constants.js